// This file contains the email sending logic for the contact form
// You'll need to set up a backend API endpoint to use this

export interface ContactFormData {
  name: string;
  email: string;
  company: string;
  message: string;
}

export async function sendContactEmail(formData: ContactFormData) {
  // Use relative path for Vercel serverless functions
  const API_ENDPOINT = '/api/contact';
  
  try {
    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData),
    });

    if (!response.ok) {
      throw new Error('Failed to send email');
    }

    return await response.json();
  } catch (error) {
    console.error('Error sending email:', error);
    throw error;
  }
}

// Example backend code for Resend (Node.js/Express)
/*
const { Resend } = require('resend');
const resend = new Resend('YOUR_RESEND_API_KEY');

app.post('/api/contact', async (req, res) => {
  const { name, email, company, message } = req.body;

  try {
    const data = await resend.emails.send({
      from: 'Setora Contact Form <noreply@setora.ai>',
      to: ['info@setora.ai'],
      cc: ['luke@setora.ai'],
      reply_to: email,
      subject: `New Contact Form Submission from ${name}`,
      html: `
        <h2>New Contact Form Submission</h2>
        <p><strong>Name:</strong> ${name}</p>
        <p><strong>Email:</strong> ${email}</p>
        <p><strong>Company:</strong> ${company || 'Not provided'}</p>
        <p><strong>Message:</strong></p>
        <p>${message}</p>
      `,
    });

    // Send confirmation email to the user
    await resend.emails.send({
      from: 'Setora.ai <noreply@setora.ai>',
      to: [email],
      subject: 'Thank you for contacting Setora.ai',
      html: `
        <h2>Thank you for reaching out!</h2>
        <p>Hi ${name},</p>
        <p>We've received your message and will get back to you soon.</p>
        <p>Best regards,<br>The Setora Team</p>
      `,
    });

    res.json({ success: true, data });
  } catch (error) {
    console.error('Error sending email:', error);
    res.status(500).json({ success: false, error: error.message });
  }
});
*/ 